<template>
<!-- 国家列表 -->
  <div chass="app-container">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:10px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>国家列表</h5>
              </span>
            </div>
            <div>
              <el-button slot="reference" size="mini" icon="el-icon-circle-plus-outline" @click="adddivshow" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px">新增国家</el-button>
              <el-button slot="reference" size="mini" icon="el-icon-delete" @click="piliangshanchu" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px">删除所选数据</el-button>
              		
              <el-table :data="tableData.page.result" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'6px 6px !important'}" class="tb-edit"  border
                v-loading="loadding"  @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="code" label="国家编码" min-width="150px">
                  </el-table-column>
                  <el-table-column prop="name" label="国家名称" min-width="150px">
                  </el-table-column>
                  <el-table-column prop="createdAt" label="添加时间" min-width="150px">
                  </el-table-column>
                  <el-table-column label="操作" width="210">
                    <template slot-scope="scope">
                      <el-button size="mini" style="padding: 4px 15px;" type="success" @click="zidingyishijianupdate(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" style="padding: 4px 15px;" type="danger" @click="zidingyishijiandelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
              </el-table>
              <div class="block" style="padding-bottom:10px">
                <el-pagination :current-page="tiaojian.pageNo" :page-sizes="[10,15, 20, 30, 50]" :page-size="tiaojian.pageSize" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength"
                  style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 添加 -->
      <el-dialog title="国家新增" :visible.sync="adddivif" width="450px">
        <el-form ref="form" :inline="true" :model="form" label-width="120px">
          <el-form-item label="国家编码">
            <el-input v-model="form.code" style="width:250px"></el-input>
          </el-form-item>
          <el-form-item label="国家名称">
            <el-input v-model="form.name" style="width:250px"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:30px;">
            <el-button style="margin-left:50px;" type="primary" @click="onSubmit">立即创建</el-button>
            <el-button @click="adddivif=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog title="国家维护" :visible.sync="updatedivif" width="450px">
        <el-form ref="form" :inline="true" :model="uform" label-width="120px">
          <el-form-item label="国家编码">
            <el-input v-model="uform.code" style="width:250px"></el-input>
          </el-form-item>
          <el-form-item label="国家名称">
            <el-input v-model="uform.name" style="width:250px"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:30px;">
            <el-button style="margin-left:50px;" type="primary" @click="onSubmituform">保存修改</el-button>
            <el-button @click="updatedivif=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { ajax_handleBusinessByTargetKpi } from "@Gms~/api/ajax_model";

import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "GS_COUNTRY",
  components: {},
  data() {
    return {

      form: {
        name: "",//()
        code: "",// ()
      },
      uform: {
        id: "",
        name: "",//()
        code: "",// ()
      },
      adddivif: false,
      updatedivif: false,
      qufu_list: [],
      guojia_list: [],
      tiaojian: {
        pageNo: 1, //   (当前页)
        pageSize: 20 //   (每页条数)
      },

      tableData: {
        page: {
          result: []
        },
        thead: []
      },
      dataLength: 0,
      loadding: false,
      multipleSelection:[],
    };
  },
  created() {
    this.list_handleBusinessByTargetKpi();
  },
  mounted() {},
  methods: {
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    list_handleBusinessByTargetKpi() {
      this.loadding = true;
      console.log(this.tiaojian);
      ajax_handleBusinessByTargetKpi(
        "gs_1_3_2",
        this.tiaojian
      ).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.tableData = response.data;
          this.dataLength = response.data.page.totalCount;
        }

        this.loadding = false;
      });
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.tiaojian.pageSize = e;
      this.list_handleBusinessByTargetKpi();
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.tiaojian.pageNo = e;
      this.list_handleBusinessByTargetKpi();
    },
    zidingyishijianupdate(index, row) {
      // 自定义事件编辑
      console.log(row);
      this.updatedivif = true;
      this.uform.id=row.id;
      this.uform.name=row.name;
      this.uform.code=row.code;
    },
    zidingyishijiandelete(index, row) {
      // 自定义事件删除
      this.$confirm('确认删除 "' + row.name + '" 吗？')
        .then(_ => {
          ajax_handleBusinessByTargetKpi("gs_1_3_4",{id:row.id}).then(response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.list_handleBusinessByTargetKpi();
            } else {
              this.$message(response.msg);
            }
          });
        })
        .catch(_ => {});
    },
    piliangshanchu() {
      // 自定义事件删除
      console.log(this.multipleSelection)
      var ids = [];
      for(var i = 0;i<this.multipleSelection.length;i++){
        ids.push(this.multipleSelection[i].id)
      }
      var datas = {id:ids.join(",")}
      this.$confirm('确认批量删除吗？')
        .then(_ => {
          ajax_handleBusinessByTargetKpi("gs_1_3_4",datas).then(response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.list_handleBusinessByTargetKpi();
            } else {
              this.$message(response.msg);
            }
          });
        })
        .catch(_ => {});
    },
    onSubmit() {
      // 添加自定义事件
      console.log(this.form);
      ajax_handleBusinessByTargetKpi("gs_1_3_3",this.form).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.list_handleBusinessByTargetKpi();
          this.adddivif = false;
        } else {
          this.$message(response.msg);
        }
      });
    },
    onSubmituform() {
      // 修改自定义事件
      console.log(this.uform);
      ajax_handleBusinessByTargetKpi("gs_1_3_3",this.uform).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.list_handleBusinessByTargetKpi();
          this.updatedivif = false;
        } else {
          this.$message(response.msg);
        }
      });
    },
    adddivshow() {
      this.adddivif = true;
      this.form.name="";
      this.form.code="";
    },
    exportExcel(e) {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#xiazaishijian")
      );
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "事件列表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    handleAgeSortChange(e) {
      console.log(e);
      if (e.order == "ascending") {
        var order = true;
      } else if (e.order == "descending") {
        var order = false;
      }
      if (e.order == null) {
        this.rz_tableData2 = JSON.parse(JSON.stringify(this.rz_tableData2copy));
      } else {
        this.rz_tableData2.tbody.sort(this.sortBy(e.prop, order));
      }
    },
    sortBy(attr, rev) {
      // 第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }

      return function(a, b) {
        // a = a[attr];
        // b = b[attr];
        if (!isNaN(Number(a[attr])) && !isNaN(Number(b[attr]))) {
          a = Number(a[attr]);
          b = Number(b[attr]);
        } else {
          a = a[attr];
          b = b[attr];
        }

        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    }
  },
  filters: {
    delFlags(value) {
      if (value == "0") {
        return "显示";
      } else if (value == "1") {
        return "隐藏";
      }
    },
    platformTypes(value) {
      if (value == "1") {
        return "服务端事件";
      } else if (value == "2") {
        return "客户端事件";
      }
    },
    eventTypes(value) {
      if (value == "0") {
        return "公共事件";
      } else if (value == "3") {
        return "必传参数";
      } else if (value == "1") {
        return "自定义事件";
      }
    },
    eventDescsub(value) {
      if (value.length > 25) {
        return value.substring(0, 25) + "...";
      } else {
        return value;
      }
    },
    eventNamesub(value) {
      if (value.length > 10) {
        return value.substring(0, 10) + "...";
      } else {
        return value;
      }
    },
    dataEmptys(value) {
      if (value == "0") {
        return "否";
      } else if (value == "1") {
        return "是";
      }
    },
    ispresets(value) {
      if (value == "0") {
        return "否";
      } else if (value == "1") {
        return "是";
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
.tb-edit ::v-deep .el-table__body-wrapper {
  z-index: 1;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 5px 2px !important;
}

.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
